import { render, staticRenderFns } from "./noteDetailModal.vue?vue&type=template&id=82bacda8&scoped=true&"
import script from "./noteDetailModal.vue?vue&type=script&lang=js&"
export * from "./noteDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./noteDetailModal.vue?vue&type=style&index=0&id=82bacda8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bacda8",
  null
  
)

export default component.exports